import React, {useState} from 'react'
import axios from 'axios'
import { useNavigate, useParams  } from 'react-router-dom'
import { useTranslation } from "react-i18next"
import { Link } from "react-router-dom"
import Swal from 'sweetalert2'
import { Container, Row, Col, Button, Form } from 'react-bootstrap'

const ResetPassword = (props) => {

    const { t } = useTranslation()

    const navigate = useNavigate()

    const [isLoading, setIsLoading] = useState(false)
    const [isCorrect, setIsCorrect] = useState("")
    const [password, setPassword] = useState("")

    const { id } = useParams()
    const { tokenresetpassword } = useParams()

    /**
     * Captura el submit del formulario y cambia la clave de la cuenta
     * @param {*} e 
     */
    const handleSubmit = async(e) => {
        e.preventDefault()

        const clientPassword = {
            password: e.target.password.value
        }

        setIsLoading(true)

        await axios.put(process.env.REACT_APP_DB_ADDRESS + '/api/forgot/resetpassword?id=' + id + '&tokenResetPassword=' + tokenresetpassword, clientPassword, {
            where: {
                id: id,
                tokenresetpassword: tokenresetpassword
            }
        })
        .then((res) => {            
            setIsLoading(false)
            navigate('/resetpasswordsuccess')
        }).catch((err) => {
            setIsLoading(false)
            Swal.fire({
                showConfirmButton: true,
                icon: 'error',
                text: t('passwordreset.sendError')
            })
        })
    }

    const checkValidation = (e) => {
        const confirmPass = e.target.value

        if (password !== confirmPass) {
            setIsCorrect(t('passwordreset.passwordsdoesnotmatch'))
        }else {
            setIsCorrect("")
        }
    }

    return (
        <div className="auth-page">
            <div className="auth-card">
                <div className="text-center mb-4">
                    <img src="/images/logo-inicio.png" alt="logotipo" height={40} />
                </div>
                <div className="login-title">{t('passwordreset.question')}</div>
                <div className="login-subtitle">{t('passwordreset.help')}</div>

                <Form onSubmit={handleSubmit}>
                    <div className="mb-3">
                        <Form.Label>{t('passwordreset.new_password')}</Form.Label>
                        <Form.Control
                            placeholder={t('passwordreset.new_password')}
                            name="password"
                            type="password"
                            autoComplete="off"
                            isInvalid={isCorrect !== ''}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                    </div>

                    <div className="mb-4">
                        <Form.Label>{t('passwordreset.confirm_password')}</Form.Label>
                        <Form.Control
                            placeholder={t('passwordreset.confirm_password')}
                            name="confirm_password"
                            type="password"
                            autoComplete="off"
                            isInvalid={isCorrect !== ''}
                            onChange={checkValidation}
                        />
                        {isCorrect !== '' && (
                            <div className="text-xs mt-1" style={{ color: 'var(--danger)' }}>
                                {t('passwordreset.passwordsdoesnotmatch')}
                            </div>
                        )}
                    </div>

                    <Button type="submit" variant="primary" className="w-100" disabled={isLoading}>
                        {isLoading ? (
                            <span className="spinner-border spinner-border-sm align-middle"></span>
                        ) : (
                            t('passwordreset.submit')
                        )}
                    </Button>

                    <div className="text-center mt-4">
                        <Link className="btn btn-secondary" to="/login">
                            <i className="fas fa-chevron-left"></i> {t('global.return')}
                        </Link>
                    </div>
                </Form>
            </div>
        </div>
    )
}

export default ResetPassword